import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { QueryOptions } from '../../repository'
import type { AiCreditTransaction } from './AiCreditTransaction'

@InputType()
export class GetMyCreditLedgerArgs extends ActionArgs {
  @Field(() => GraphQLJSON, { nullable: true })
  options?: QueryOptions<AiCreditTransaction>
}

export interface IGetMyCreditLedger extends IAction<AiCreditTransaction[], GetMyCreditLedgerArgs> {}
